<template>
  <div style="display: flex; position: relative; width: 100%; height: 100%">

    <div style="flex-grow: 1; max-width: calc(100vw - 256px);">

			<CargaInicial v-if="$root.dominios.cargando"></CargaInicial>

			<v-sheet v-else-if="dominio && dominio.datos.sitio" id="sitio" style="position: relative; height: calc(100vh - 64px); overflow-y: auto; overflow-x: hidden">
				<Navegacion
					v-model="dominio.datos.sitio"
					@página="cambiarPágina($event)"
				></Navegacion>
				<Encabezado v-model="dominio.datos.sitio.encabezado"></Encabezado>
				<div id="main" v-if="página" :class="cuerpo.clases">
					<Seccion
						v-for="(s, i) in página.secciones"
						:key="`cnsttr-dts-sccn-${i}${$root.aleatorio()}`"
						v-model="página.secciones[i]"
						:cantidadDeSecciones="página.secciones.length"
						:posición="i"
						@eliminar="eliminarSección(i)"
						@subir="subirSección(i)"
						@bajar="bajarSección(i)"
						@editar="editarSección(i)"
					>
					</Seccion>
				</div>
				<Piedepagina
					v-model="dominio.datos.sitio.pie_de_página"
					:configuración="dominio.datos.sitio.configuración"
				></Piedepagina>
				<ContactoBotonFlotante
					v-model="dominio.datos.sitio.botónFlotante"
					:contacto="dominio.datos.sitio.configuración.contacto"
				></ContactoBotonFlotante>
			</v-sheet>

			<v-row v-else>
				<v-col cols="12" sm="6" md="4" lg="2" offset-lg="5" offset-md="4" offset-sm="3">
					<v-alert type="error" :icon="false" class="text-center">
						<v-icon>mdi-alert</v-icon> [4393] Ocurrió un error.
					</v-alert>
				</v-col>
			</v-row>
		</div>

		<v-navigation-drawer
			v-if="dominio"
			permanent
			right
			:width="256"
			style="flex-grow: 0; flex-shrink: 0; flex-basis: 256px; height: calc(100vh - 64px); overflow: auto"
    >

			<v-card>
				<v-menu
					:close-on-content-click="false"
					:nudge-left="500"
					max-height="600px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs" v-on="on"
							color="blue-grey"
							class="ma-2 white--text"
							@click="loader = 'loading3'"
						>
							<v-icon dark>
								mdi-cog
							</v-icon>
							Configuración
						</v-btn>
					</template>
					<v-card style="width: 500px">
						<v-card-title>Configuración de la página</v-card-title>
						<v-card-text>

							<v-select
								label="Anchura máxima del contenido principal de la página:"
								:items="cuerpo.anchura.opciones"
								v-model="cuerpo.anchura.valor"
							></v-select>

							<v-select
								label="Borde del contenido principal de la página:"
								:items="cuerpo.borde.opciones"
								v-model="cuerpo.borde.valor"
								:disabled="!cuerpo.anchura.valor"
							></v-select>

							<v-divider></v-divider>

							<ConfiguracionRedesSociales v-model="dominio.datos.sitio.configuración.contacto"></ConfiguracionRedesSociales>

						</v-card-text>
					</v-card>
				</v-menu>
			</v-card>

			<v-card class="text-center">
				<v-btn color="indigo" class="ma-2" tile dark dddddark="!guardando" @click="guardar(true)" :loading="guardando">Guardar</v-btn>
				<v-btn color="pink" tile dark @click="preparandoPublicación = true">Publicar</v-btn>
			</v-card>

			<v-card v-if="dominio">

				<v-card style="max-height: 200px; overflow: auto" class="pb-0" elevation="0">
					<v-list-item style="min-height: 25px" class="mt-2">
						<div style="width: 18px; margin-right: 8px"></div>
						<v-list-item-content class="py-0">
							<v-list-item-title style="font-size: 1.1rem; color: #666"><strong>Páginas:</strong></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<div style="width: 18px; margin-right: 8px"></div>
						<v-list-item-icon class="mr-2 my-3">
							<v-icon style="cursor: pointer;" v-if="páginaSeleccionada === 'principal'" color="green">mdi-radiobox-marked</v-icon>
							<v-icon style="cursor: pointer;" v-else @click="páginaSeleccionada = 'principal'">mdi-radiobox-blank</v-icon>
						</v-list-item-icon>
						<v-list-item-content style="cursor: pointer;" @click="páginaSeleccionada = 'principal'">
							<v-list-item-title style="font-size: 1.1rem" v-if="páginaSeleccionada === 'principal'"><strong>Página principal</strong></v-list-item-title>
							<v-list-item-title style="font-size: 1.1rem" v-else>Página principal</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item v-for="(p, i) in dominio.datos.sitio.otras_páginas" :key="`pgna-${i}`" style="bborder-bottom: 1px solid silver">
						<div style="width: 18px; margin-right: 8px">
							<v-icon size="18" style="cursor: pointer" @click="subirPágina(i)" title="Mover página arriba" v-if="i > 0">mdi-arrow-up-bold</v-icon>
							<v-icon size="18" style="cursor: pointer" @click="bajarPágina(i)" title="Mover página abajo" v-if="i+1 < dominio.datos.sitio.otras_páginas.length">mdi-arrow-down-bold</v-icon>
						</div>
						<v-list-item-icon class="mr-2 my-3" style="cursor: pointer">
							<v-icon v-if="páginaSeleccionada == i" color="green">mdi-radiobox-marked</v-icon>
							<v-icon v-else @click="páginaSeleccionada = i">mdi-radiobox-blank</v-icon>
						</v-list-item-icon>
						<v-list-item-content style="cursor: pointer;" @click="páginaSeleccionada = i">
							<v-list-item-title style="font-size: 1.1rem" v-if="páginaSeleccionada == i"><strong>{{ p.título }}</strong></v-list-item-title>
							<v-list-item-title style="font-size: 1.1rem" v-else>{{ p.título }}</v-list-item-title>
						</v-list-item-content>
						<v-list-item-action class="my-1">
							<v-btn icon @click="eliminarPágina(i)" title="Eliminar página">
								<v-icon color="grey lighten-1">mdi-delete</v-icon>
							</v-btn>
						</v-list-item-action>
					</v-list-item>
				</v-card>

				<v-card-text>
					<span style="cursor: pointer;" class="pl-6" role="button" @click="agregandoPágina = true"><v-icon>mdi-plus</v-icon> Agregar otra página</span>
				</v-card-text>

			</v-card>

			<v-list three-line>
				<template v-for="(sección, i) in secciones">

					<v-list-item
						:key="`cnsttr-sccns-${i}`"
						@click="agregarSección(sección.definición)"
						style="min-height: unset"
						:class="{ 'pa-2': !sección.título }"
					>

						<v-list-item-icon v-if="sección.ícono">
							<v-icon>{{ sección.ícono }}</v-icon>
						</v-list-item-icon>
						<div v-else v-html="sección.imagenSVG" style="border: 1px solid #eee;"></div>

						<v-list-item-content class="py-0 pl-2">
							<v-list-item-title v-if="sección.título" v-html="sección.título"></v-list-item-title>
							<v-list-item-subtitle v-else v-html="sección.descripción" style="line-clamp: 3;"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-divider :key="i"></v-divider>

				</template>

			</v-list>

    </v-navigation-drawer>

		<v-navigation-drawer
			v-model="editandoSección"
			absolute
			bottom
			temporary
			right
		>
			<SeccionConfigurar v-model="sección" @cerrar="cerrarEdiciónDeSección()"></SeccionConfigurar>
		</v-navigation-drawer>

		<v-dialog
      v-model="preparandoPublicación"
      max-width="800"
    >
      <v-card v-if="dominio">
				<v-card-title>Publicar el sitio</v-card-title>
				<v-card-text>
					Estás a punto de punto de publicar el sitio web en internet. El sitio web accesible ahora en «{{ dominio.identificador }}» será reemplazado por este nuevo diseño. ¿Estás seguro de hacer esta actualización?
				</v-card-text>
				<v-card-actions>
					<v-btn text color="deep-purple accent-4" @click="publicar" :loading="publicando">Sí, publicar</v-btn>
					<v-btn text @click="preparandoPublicación = false" :disabled="publicando">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

		<v-dialog
      v-model="agregandoPágina"
      max-width="500"
    >
      <v-card>
				<v-card-title>Agrega una nueva página al sitio</v-card-title>
				<v-card-text>
					<v-text-field label="Escribe aquí el nombre de la página, p.e. «Servicios»" v-model="títuloPáginaNueva"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="deep-purple accent-4" @click="agregarPágina()" :disabled="!títuloPáginaNueva">Agregar</v-btn>
					<v-btn text @click="agregandoPágina = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

  </div>
</template>

<script>

import { SeccionesPreestablecidas } from '@/components/constructor/secciones'
import CargaInicial from '@/views/CargaInicial'
import Encabezado from '@/components/constructor/Sitio/Encabezado'
import Seccion from '@/components/constructor/Sitio/Pagina/Seccion/Seccion'
import SeccionConfigurar from '@/components/constructor/Sitio/Pagina/Seccion/SeccionConfigurar'
import Navegacion from '@/components/constructor/Sitio/Navegacion'
import Piedepagina from '@/components/constructor/Sitio/Piedepagina'
import ConfiguracionRedesSociales from '@/components/constructor/Sitio/ConfiguracionRedesSociales.vue'
import ContactoBotonFlotante from '@/components/constructor/Sitio/ContactoBotonFlotante.vue'

export default {
  name: 'dominio-constructor-vista',

  components: {
		CargaInicial,
		Navegacion,
		Seccion,
		SeccionConfigurar,
		Piedepagina,
		Encabezado,
		ConfiguracionRedesSociales,
		ContactoBotonFlotante
  },

  data: () => ({
		guardando: false,

		preparandoPublicación: false,
		publicando: false,

		dominio: null,

		páginaSeleccionada: '',
		títuloPáginaNueva: '',
		página: null,

		agregandoPágina: false,

		secciones: SeccionesPreestablecidas,

		editandoSección: false,
		sección: null,

		cuerpo: {
			clases: {},
			anchura: {
				valor: '',
				opciones: [
					{ 'text': '1200 pixeles', 'value': 'anchura-1200px' },
					{ 'text': '1400 pixeles', 'value': 'anchura-1400px' },
					{ 'text': 'Todo el ancho de la pantalla', 'value': '' }
				]
			},
			borde: {
				valor: '',
				opciones: [
					{ 'text': 'Sin borde', 'value': '' },
					{ 'text': 'Borde simple', 'value': 'borde' },
					{ 'text': 'Borde con sombreado', 'value': 'borde-sombreado' },
				]
			}
		},

	}),

	watch: {
		'página': function() {
			this.aplicarClasesDeCuerpo()
		},
		'cuerpo.anchura.valor': function() {
			this.aplicarClasesDeCuerpo()
		},
		'cuerpo.borde.valor': function() {
			this.aplicarClasesDeCuerpo()
		},
		'$root.dominios.cargando': function(val) {
			if (val) {
				return
			}

			this.cargarDominio()
		},
		páginaSeleccionada: function(v) {
			if (v === 'principal') {
				this.página = this.dominio.datos.sitio.página_principal
				return
			}

			for (let i in this.dominio.datos.sitio.otras_páginas) {
				if (i == v) {
					this.página = this.dominio.datos.sitio.otras_páginas[i]
					return
				}
			}

			this.página = null
			console.error('[75932] Ocurrió un error', v)
			this.$root.error('[75932] Ocurrió un error')
		},
		dominio: function(v) {
			if (!v) {
				return
			}

			if (this.dominio.datos.sitio.página_principal.clases['anchura-1200px']) {
				this.$set(this.cuerpo.anchura, 'valor', 'anchura-1200px')
				this.$delete(this.dominio.datos.sitio.página_principal.clases, 'anchura-1200px')
				for (let i in this.dominio.datos.sitio.otras_páginas) {
					this.$delete(this.dominio.datos.sitio.otras_páginas[i].clases, 'anchura-1200px')
				}
			} else if (this.dominio.datos.sitio.página_principal.clases['anchura-1400px']) {
				this.$set(this.cuerpo.anchura, 'valor', 'anchura-1400px')
				this.$delete(this.dominio.datos.sitio.página_principal.clases, 'anchura-1400px')
				for (let i in this.dominio.datos.sitio.otras_páginas) {
					this.$delete(this.dominio.datos.sitio.otras_páginas[i].clases, 'anchura-1400px')
				}
			}

			if (this.dominio.datos.sitio.página_principal.clases['borde']) {
				this.$set(this.cuerpo.borde, 'valor', 'borde')
			}
			if (this.dominio.datos.sitio.página_principal.clases['sombreado']) {
				this.$set(this.cuerpo.borde, 'valor', 'borde-sombreado')
			}

			// Cambio en formato de estructura a partir del 2021-07-23
			if (!this.dominio.datos.sitio.configuración) {
				let conIni = {
					contacto: {
						medios: {
							correoElectrónico: {
								valor: ''
							},
							númeroTelefónico: {
								valor: ''
							},
							whatsapp: {
								valor: ''
							},
							instagram: {
								valor: ''
							},
							facebook: {
								valor: ''
							},
							twitter: {
								valor: ''
							},
							youtube: {
								valor: ''
							},
							linkedin: {
								valor: ''
							}
						}
					}
				}
				this.$set(this.dominio.datos.sitio, 'configuración', conIni)
			}

			// Cambio en formato de estructura de encabezado a partir del 2021-07-28
			if (!this.dominio.datos.sitio.encabezado.sección) {
				let sccn = {
					columnas: [
						{
							partes: [
								{
									tipo: 'texto',
									texto: this.dominio.datos.sitio.encabezado.texto,
									clases: {},
									estilos: {},
								}
							],
							clases: {},
							estilos: {
								'display': 'flex',
								'flex-grow': '1'
							}
						}
					],
					clases: {},
					estilos: {}
				}
				this.$set(this.dominio.datos.sitio.encabezado, 'sección', sccn)
			}

			// Botón flotante de contacto a partir del 2021-08-09
			if (!this.dominio.datos.sitio.botónFlotante) {
				let bf = {
					habilitado: false,
					medio: 'whatsapp',
					texto: '',
					tamaño: '50px'
				}
				this.$set(this.dominio.datos.sitio, 'botónFlotante', bf)
			}

			// Menú personalizado a partir del 2021-08-16
			if (!this.dominio.datos.sitio.menú) {
				let menú = {
					personalizado: false,
					elementos: [],
				}
				this.$set(this.dominio.datos.sitio, 'menú', menú)
			}
		}
	},

	beforeMount: function() {
		this.cargarDominio()
	},

	mounted: function() {
		this.$emit('ocultarMenu')
	},

	methods: {
		guardar: function(aviso) {
			aviso = aviso === true || aviso === undefined

			Object.keys(this.cuerpo.clases).forEach((clase) => {
				if (this.cuerpo.clases[clase]) {
					this.dominio.datos.sitio.página_principal.clases[clase] = true
					for (let i in this.dominio.datos.sitio.otras_páginas) {
						this.dominio.datos.sitio.otras_páginas[i].clases[clase] = true
					}
				}
			})

			this.guardando = true
			return this.$root.firestore.collection('dominios').doc(this.dominio.identificador).update({sitio: this.dominio.datos.sitio}).then( docRef => {
				if (aviso) {
					this.$root.correcto('Guardado. Aún no se ha publicado. Usa el botón «Publicar» para que se vea la actualización del sitio en internet.')
				}
				this.guardando = false
				return docRef
			}).catch( error => {
				console.error(error)
				if (aviso) {
					this.$root.error('Ocurrió un error. Aegúrate de que no le falte contenido al sitio.')
				}
				this.guardando = false
				return error
			})
		},
		publicar: function() {
			if (!this.dominio || !this.dominio.identificador) {
				this.$root.error('[5328] Ocurrió un error. Recarga la página e intenta de nuevo.')
				return
			}

			// empiezan pruebas
			//
			//
			//
			//this.$root.firebase.auth()
			/*
			console.log('ttt', this.$root.usuario.token)
			this.$root.axios({baseURL: `https://us-central1-sitios-c19fc.cloudfunctions.net/api`, url: '/v1/dominios/saulortega.co', method: 'GET', headers: { 'Authorization': `Bearer ${this.$root.usuario.token}`, 'X-Cuenta': this.$root.cuenta.identificador } }).then( response => {
			console.log('biennnnn', response)
			}).catch( error => {
				console.log('eeeerrrrr', error)
			})
			return
			*/
			//
			//
			//
			// terminan pruebas

			this.publicando = true
			this.guardar(false).then( () => {
				this.$root.axios.put(`/sitios/${this.dominio.identificador}`).then( response => {
				//this.$root.axios.post(`/sitios/probandodominio`, this.dominio.datos.sitio).then( response => {
					this.$root.correcto(`¡LISTO! :) El sitio ya está publicado. Entra a http://${this.dominio.identificador} para comprobarlo.`)
					this.preparandoPublicación = false
					this.publicando = false
				}).catch( error => {
					console.error(error, error.response)
					let err = '[7931] Ocurrió un error'
					if (error && error.response && error.response.headers && error.response.headers['x-error']) {
						try {
							err = decodeURIComponent(escape(error.response.headers['x-error']))
						} catch {
							console.warn('[7932]')
							err = error.response.headers['x-error']
						}
					}
					this.$root.error(err)
					this.publicando = false
				})
			}).catch( () => {
				this.publicando = false
			})
		},
		agregarSección(d) {
			this.página.secciones.push(JSON.parse(JSON.stringify(d)))
		},
		eliminarSección: function(i) {
			this.$delete(this.página.secciones, i)
		},
		subirSección: function(i) {
			let sccn = this.página.secciones[i]
			this.página.secciones.splice(i, 1)
			this.página.secciones.splice(i-1, 0, sccn)
		},
		bajarSección: function(i) {
			let sccn = this.página.secciones[i]
			this.página.secciones.splice(i, 1)
			this.página.secciones.splice(i+1, 0, sccn)
		},
		editarSección: function(i) {
			this.sección = this.página.secciones[i]
			this.editandoSección = true
		},
		cerrarEdiciónDeSección: function() {
			this.editandoSección = false
			this.sección = null
		},
		cargarDominio: function() {
			let D = this.$root.obtenerDominio(this.$route.params.dominio)
			if (D && !D.datos.sitio) {
				this.$set(D.datos, 'sitio', this.objetoSitioPredeterminado())
			}

			this.dominio = D

			if (this.dominio) {
				this.páginaSeleccionada = 'principal'
			}
		},
		cambiarPágina: function(p) {
			this.páginaSeleccionada = p
		},
		agregarPágina: function() {
			if (!this.títuloPáginaNueva) {
				this.$root.error('Escribe un título para la página')
				return
			}

			let p = {
				título: this.títuloPáginaNueva,
				secciones: [],
				clases: {}
			}
			this.dominio.datos.sitio.otras_páginas.push(p)
			this.páginaSeleccionada = this.dominio.datos.sitio.otras_páginas.length - 1

			this.títuloPáginaNueva = ''
			this.agregandoPágina = false
		},
		eliminarPágina: function(i) {
			this.$delete(this.dominio.datos.sitio.otras_páginas, i)

			if (this.páginaSeleccionada == i) {
				this.páginaSeleccionada = 'principal'
			}
		},
		subirPágina: function(i) {
			let pgna = this.dominio.datos.sitio.otras_páginas[i]
			this.dominio.datos.sitio.otras_páginas.splice(i, 1)
			this.dominio.datos.sitio.otras_páginas.splice(i-1, 0, pgna)

			if (this.páginaSeleccionada == i) {
				this.páginaSeleccionada = Number(i) - 1
			} else if (this.páginaSeleccionada == i-1) {
				this.páginaSeleccionada = i
			}
		},
		bajarPágina: function(i) {
			let pgna = this.dominio.datos.sitio.otras_páginas[i]
			this.dominio.datos.sitio.otras_páginas.splice(i, 1)
			this.dominio.datos.sitio.otras_páginas.splice(i+1, 0, pgna)

			if (this.páginaSeleccionada == i) {
				this.páginaSeleccionada = Number(i) + 1
			} else if (this.páginaSeleccionada == i+1) {
				this.páginaSeleccionada = i
			}
		},
		objetoSitioPredeterminado: function() {
			return {
				título: '',
				logotipo: '',
				encabezado: {
					texto: '<h1>Escribe aquí una introducción...</h1>',
					estilos: {
						'height': '300px',
						//'background-image': "url('https://images.pexels.com/photos/796637/pexels-photo-796637.jpeg')",
						'background-image': "url('https://www.publicdomainpictures.net/pictures/170000/velka/grunge-background-146356047033U.jpg')",
					}
				},
				página_principal: {
					secciones: [],
					clases: {}
				},
				otras_páginas: [],
				pie_de_página: {}
			}
		},
		aplicarClasesDeCuerpo: function() {
			this.cuerpo.clases['anchura-1200px'] = this.cuerpo.anchura.valor === 'anchura-1200px'
			this.cuerpo.clases['anchura-1400px'] = this.cuerpo.anchura.valor === 'anchura-1400px'
			this.cuerpo.clases['borde'] = this.cuerpo.anchura.valor && this.cuerpo.borde.valor.indexOf('borde') === 0
			this.cuerpo.clases['sombreado'] = this.cuerpo.anchura.valor && this.cuerpo.borde.valor === 'borde-sombreado'
		}
		//
	}
};

</script>

<style scoped>

#main:not(.anchura-1200px):not(.anchura-1400px) {
	margin-left: 36px !important;
	width: 100%;
}

#sitio .anchura-1400px {
    max-width: min(1400px, calc(100vw - 256px)) !important;
}

#sitio .anchura-1200px {
    max-width: min(1200px, calc(100vw - 256px)) !important;
}

</style>